import PropTypes from 'prop-types'
import React from 'react'
import { Item } from '../Item'
import { connect } from 'react-redux'
import { getCurrentAd, getSpecsIdForMainProps } from '../../../selectors'

const isValidSvgIconUri = uri => {
  const parts = uri ? uri.split('.') : null

  if (Array.isArray(parts) && parts.length) {
    const extension = parts[parts.length - 1]
    if (extension === 'svg') return true
  }

  return false
}

export const List = ({ad, specs}) => {
  const items = []
  if (Array.isArray(ad.adsSpecifications)) {
    specs.forEach(item => {
      const findSpecification = ad.adsSpecifications.find(
        specification => specification.specification && specification.specification.id === item
      )

      if (findSpecification) {
        const { specification, value } = findSpecification
        if (!specification) return null

        const {
          title,
          measure,
          icon,
          optionsIcon,
          options
        } = specification

        let iconSvg = specification.iconSvg

        if (Array.isArray(optionsIcon) && optionsIcon.length) {
          const findOptionIndex = Array.isArray(options)
            ? options.findIndex(specOption => specOption === value)
            : -1

          if (findOptionIndex !== -1 && optionsIcon[findOptionIndex]) {
            console.log('findOptionIndex', findOptionIndex)
            const svgSpecIcon = optionsIcon[findOptionIndex]

            if (isValidSvgIconUri(svgSpecIcon)) {
              iconSvg = svgSpecIcon
            }
          }
        }

        console.log('findSpecification', findSpecification)
        items.push({
          id: findSpecification.id,
          ico: icon,
          iconSvg,
          value: findSpecification.value,
          unit: measure,
          title: title.toLowerCase()
        })
      }
    })
  }

  return (
    <div className='oglasi-glavne-informacije'>
      {
        items.map(item => (
          <Item
            key={item.id}
            icon={item.ico}
            iconSvg={item.iconSvg}
            unit={item.unit}
            value={item.value}
            title={item.title}
          />
        ))
      }
    </div>
  )
}

const mapStateToProps = state => ({
  ad: getCurrentAd(state),
  specs: getSpecsIdForMainProps(state)
})

List.propTypes = {
  ad: PropTypes.shape({
    adsSpecifications: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      value: PropTypes.string.isRequired,
      specification: PropTypes.object.isRequired
    }))
  }).isRequired,
  specs: PropTypes.arrayOf(PropTypes.number)
}

List.defaultProps = {
  specs: []
}

List.displayName = 'MainProps'

export default connect(mapStateToProps)(List)
